import React from 'react';
import BrandLogo from '@/components/BrandLogo';
import Footer from './Footer';
import ConciergeOtoStep from './ConciergeOtoStep';

// §concierge-oto — /concierge-offer-preview: the offer page exactly as a New
// York patient sees it after paying, with inert buttons. For design review
// before the backend ships; no visit, no charge, no flag needed.
// A sample of the server's offer so the preview shows the consent block the
// way a patient will see it (real text comes from GET /concierge/oto/offer).
const SAMPLE_CONSENT = 'By clicking Add, you authorize Mavroson Medical, P.C. to charge the card on file now and automatically each month until you cancel (full refund within 2 days of enrolment, then 30 days\' notice), and to receive the health information you provided in this visit for your care. New York auto-renewal disclosure: you may cancel at any time from your patient dashboard or by email.';
const SAMPLE_OFFER = {
  advancedPeptide: { todayCents: 29900, monthlyCents: 29900, consentText: SAMPLE_CONSENT },
  advancedWeightLoss: { todayCents: 14900, monthlyCents: 14900, consentText: SAMPLE_CONSENT },
  advancedLongevity: { todayCents: 19900, monthlyCents: 29900, consentText: SAMPLE_CONSENT },
};
const SAMPLE_ANSWERS = {
  'basic-contact': { name: 'Jordan Rivera', email: 'jordan@example.com' },
  'shipping-address': { state: 'NY', city: 'Brooklyn', zipCode: '11201' },
};

const ConciergeOtoPreview = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <header className="w-full px-4 pt-6 pb-3">
      <div className="max-w-5xl mx-auto text-center">
        <BrandLogo alt="FitPal" className="mx-auto mb-2 w-56 h-auto" />
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg inline-block px-3 py-1" data-testid="oto-preview-banner">
          Design preview — buttons are inert, nothing is charged.
        </p>
      </div>
    </header>
    <main className="flex-1 px-4 py-6">
      <ConciergeOtoStep answers={SAMPLE_ANSWERS} visitType="weightloss" preview offer={SAMPLE_OFFER} onContinue={() => window.alert('Preview: would continue to the confirmation screen.')} />
    </main>
    <div className="shrink-0"><Footer /></div>
  </div>
);

export default ConciergeOtoPreview;
